import * as React from "react"
import type { SVGProps } from "react"
const SvgNewspaper = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 21.71q-.82 0-1.41-.58A2 2 0 0 1 2 19.7V4.31q0-.17.15-.23.16-.07.28.06l1.24 1.25 1.3-1.33a.5.5 0 0 1 .7 0L7 5.4l1.33-1.32a.5.5 0 0 1 .7 0l1.3 1.32 1.32-1.32a.5.5 0 0 1 .7 0l1.32 1.32 1.3-1.32a.5.5 0 0 1 .7 0L17 5.39l1.33-1.32a.5.5 0 0 1 .7 0l1.3 1.32 1.25-1.25q.12-.12.27-.06t.15.23v15.4q0 .83-.59 1.42a2 2 0 0 1-1.41.59zm0-2h7v-6H4zm9 0h7v-2h-7zm0-4h7v-2h-7zm-9-4h16v-3H4z" />
  </svg>
)
export default SvgNewspaper
